import { ValidationResultResponse } from '@zond/api-interfaces';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';

export function setFormErrors<T extends FieldValues>(
  form: UseFormReturn<T>,
  error: ValidationResultResponse
) {
  error.validations.forEach((validation) => {
    Object.entries(validation.constraints).forEach(([key, value]) => {
      form.setError(validation.context as Path<T>, {
        type: key,
        message: value,
      });
    });
  });
}
